import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider as ReduxProvider } from 'react-redux'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './authConfig'
import store from 'store'
import Snowfall from 'react-snowfall'
import { isChristmas } from 'helper/date'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ThemeProvider } from 'styled-components';

const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

// ✅ Controle global para evitar double reload
let isReloading = false;

// Branding
document.body.setAttribute("data-brand", "rede-dor");
// document.body.setAttribute("data-brand", "star");

// Tema
document.body.setAttribute('data-theme', 'light');

// Efeito sazonal
let effect = <></>;
if (isChristmas()) {
  effect = <Snowfall snowflakeCount={6} />;
}

// Render
root.render(
  <>
    {effect}
    <ThemeProvider theme={{ color: {} }}>
      <MsalProvider instance={msalInstance}>
        <ReduxProvider store={store}>
          <App />
        </ReduxProvider>
      </MsalProvider>
    </ThemeProvider>
  </>
)

// Service Worker (usuário já está na aplicação)
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (isReloading) return;
    isReloading = true;

    console.log('Nova versão detectada via Service Worker');

    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
     
    setTimeout(() => {
      forceReload();
    }, 300);

  },
});


// Check de versão ao abrir aplicação (index.html)
async function checkVersionOnLoad() {
  try {
    const response = await fetch('/version.json?cache=' + new Date().getTime());
    const data = await response.json();

    const storedVersion = localStorage.getItem('app_version');

    // Primeira execução
    if (!storedVersion) {
      localStorage.setItem('app_version', data.version);
      return;
    }

    // Mudança de versão
    if (storedVersion !== data.version) {
      if (isReloading) return;
      isReloading = true;

      console.log('Nova versão detectada ao acessar a aplicação');

      localStorage.setItem('app_version', data.version);

      window.alert('O sistema foi atualizado. A página será recarregada.');

      forceReload()
    }
  } catch (err) {
    console.warn('Falha ao verificar versão (ignorado)');
  }
}

// ✅ Evita conflito com inicialização do app
setTimeout(() => {
  checkVersionOnLoad();
}, 1000);


// Metrics
reportWebVitals();

async function forceReload() {
  try {
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map(name => caches.delete(name)));
    }

    const url = new URL(window.location.href);
    url.searchParams.set('v', new Date().getTime().toString());

    window.location.replace(url.toString());

  } catch (e) {
    console.warn('Falha ao limpar cache, fazendo reload padrão');
    window.location.reload();
  }
}
